const AppTypes = {
  ANALYTICS: 'Analytics',
  BROADCAST_LISTS: 'BroadcastLists',
  CLINICAL_WORKFLOWS: 'ClinicalWorkflows',
  COLLABORATION: 'Roles&Teams',
  MESSAGES: 'Messages',
  PATIENT_SETTINGS: 'PatientSettings',
  ROLES: 'Roles',
  SETTINGS: 'Settings',
  TEAMS: 'Teams',
  VIRTUAL_WAITING: 'VirtualWaiting',
  PATIENT_DIRECTORY: 'PatientDirectory',
  SERVER_CONFIG: 'ServerConfig',
} as const;

export type AppType = keyof typeof AppTypes;

export default AppTypes;
